<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row d-flex justify-content-between align-items-center mb-3">
      <div class="col-10 d-flex align-items-center">
        <h4
          class="card-title m-0 offcanvas-header-text d-flex align-items-center"
        >
          {{ "GENERALS.ASSIGNPOSTTAG" | translate }}
          <i
            class="mdi mdi-information-outline font-size-16 ms-1"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Add Tags to your Post."
          ></i>
        </h4>
      </div>
      <div class="col-2 d-flex justify-content-end">
        <ui-switch
          [color]="offcanvasColors.activeColor"
          [switchColor]="offcanvasColors.switchColor"
          [defaultBgColor]="offcanvasColors.bgColor"
          [defaultBoColor]="offcanvasColors.borderColor"
          [checkedTextColor]="offcanvasColors.activeTextColor"
          [uncheckedTextColor]="offcanvasColors.offTextColor"
          uncheckedLabel="Off"
          [checked]="enablePostTags"
          checkedLabel="On"
          size="small"
          class="me-1"
          (change)="togglePostTags($event)"
        ></ui-switch>
      </div>
    </div>
    <div
      class="row d-flex align-items-center justify-content-between align-items-center mb-3"
    >
      <div>
        <label class="form-label offcanvas-header-text"> Add Tags </label>
        <ng-select
          [items]="page"
          bindLabel="name"
          bindValue="id"
          placeholder="Select Tags"
          class="custom-select"
          [(ngModel)]="post_tag_values"
          [multiple]="true"
          [disabled]="!enablePostTags"
          (change)="updatePostTags()"
        >
        </ng-select>
      </div>
    </div>
  </div>
</div>

<ng-template #tagsSelector let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="selector">{{ "USERS.ADDROLE" | translate }}</h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="modalRef.hide()"
    ></button>
  </div>
  <div class="modal-body p-0">
    <app-tags-selector
      [mode]="'selector'"
      [chatID]="mainChat"
      (selectedNotifier)="selectedUsersf($event)"
      (cancelNotifier)="modalRef.hide()"
    ></app-tags-selector>
  </div>
</ng-template>
